export default {
    home:'/',
    first : '/first',
    second : '/second',
    check : '/check',
    pay : '/pay',
    level : '/level',
    startWithCode : '/start-with-code',
    startWithoutCode : '/start-without-code',
    priority : '/priority',
    chance : '/chance',
    lock: '/lock'
}
